import React from 'react'

import Background from '../../assets/img/backgrounds/bg-home.webp'

const JudicialGuaranteeAppeal = React.lazy(() => import('./quotations/judicial-guarantee-appeal/JudicialGuaranteeAppeal'))
const JudicialGuaranteeAppealConfirmation = React.lazy(() => import('./quotations/judicial-guarantee-appeal-details/JudicialGuaranteeAppealConfirmation'))
const GuaranteeBid = React.lazy(() => import('./quotations/guarantee-bid/GuaranteeBid'))
const GuaranteeBidConfirmation = React.lazy(() => import('./quotations/guarantee-bid-details/GuaranteeBidConfirmation'))
const GuaranteePerformance = React.lazy(() => import('./quotations/guarantee-performance/GuaranteePerformance'))
const GuaranteePerformanceConfirmation = React.lazy(() => import('./quotations/guarantee-performance-details/GuaranteePerformanceConfirmation'))

const MultiCalculationChildrenRoutes = [
  {
    path: '/judicial-deposito-recursal',
    Component: JudicialGuaranteeAppeal,
    bgImage: Background,
  },
  {
    path: '/judicial-deposito-recursal/confirmacao',
    Component: JudicialGuaranteeAppealConfirmation,
    bgImage: Background,
  },
  {
    path: '/garantia-licitante',
    Component: GuaranteeBid,
    bgImage: Background,
  },
  {
    path: '/garantia-licitante/confirmacao',
    Component: GuaranteeBidConfirmation,
    bgImage: Background,
  },
  {
    path: '/garantia-performance',
    Component: GuaranteePerformance,
    bgImage: Background,
  },
  {
    path: '/garantia-performance/confirmacao',
    Component: GuaranteePerformanceConfirmation,
    bgImage: Background,
  },
]

export default MultiCalculationChildrenRoutes
